import React from 'react'
import BusinessLoanForm from './Components/BusinessLoanForm'

const BusinessLoan = () => {

    return (
        <div>
            {/* x---------------------------------x Business Loan Section x---------------------------------x */}
            <div className="row g-3">
                <div className="col-sm-12">
                    <div className="card h-100">
                        <div className="card-header justify-content-between">
                            <h3 className="text-dark fs-5 fw-semibold ">Apply for a loans</h3>
                        </div>
                        <div className="rounded-4 mb-3 mb-sm-0 bg-white">
                            <div className="card-body rounded p-4">
                                {/* x---------------------------------x Business Loan Form x---------------------------------x */}
                                <BusinessLoanForm />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BusinessLoan